import firebase from "firebase/app";
import "firebase/performance";
import "firebase/analytics";
import "firebase/messaging";
import { notificationsFlag, firebaseAnalyticsFlag, chatOrdersFlag } from 'config';
import StorageService from 'services/StorageService';
import PubSub from "services/PubSub";

let _messaging = null;
let _analytics = null;

const PushNotification = {
    initialize: () => {
        if(typeof navigator === 'undefined') return false;

        try{
            const disableNotification =  StorageService.getItem('notification-disable');

            if(firebase && firebase.initializeApp){
                const initializedFirebaseApp = firebase.initializeApp({
                    apiKey: "AIzaSyAy4R6ouZE_y6Bw9A-qBLEk-2ek1BY7_sM",
                    authDomain: "cohesive-photon-232917.firebaseapp.com",
                    databaseURL: "https://cohesive-photon-232917.firebaseio.com",
                    projectId: "cohesive-photon-232917",
                    storageBucket: "cohesive-photon-232917.appspot.com",
                    messagingSenderId: "360337214301",
                    appId: "1:360337214301:web:9baaec0033b348b14eb6b4",
                    measurementId: "G-XLPL1HXJ24"
                });

                if(firebaseAnalyticsFlag && firebase.analytics) {
                    _analytics = firebase.analytics();
                }

                if(firebase.performance) firebase.performance();

                if(firebase.messaging && firebase.messaging.isSupported() && notificationsFlag && !disableNotification && initializedFirebaseApp.messaging){
                    _messaging = initializedFirebaseApp.messaging();
                }
            }
        } catch (e) {
            /* eslint-disable no-console */
            console.log(e);
        }
    },
    init: () => {
        if(!(notificationsFlag && _messaging)) return false;

        _messaging.getToken({vapidKey: 'BEKgh97O0kx1ztQl6LGMHRnOUmK2mdyOYsmgqKiD4xuiE7yFo3TEa8T2ukw_CMLDxtzlnUu4_0YsGAmD8LYZAnc'}).then(token => {
            PushNotification.register(token);
        }).catch(err => {
            /* eslint-disable no-console */
            console.log("Unable to get permission to notify.", err);
            /* eslint-enable no-console */
        });

        /* eslint-disable no-console */
        /* eslint-enable no-console */
        if(chatOrdersFlag){
            navigator.serviceWorker.addEventListener("message", (message) => {
                const payload = message?.data?.firebaseMessaging?.payload;
                if(payload?.data?.urlTarget == '_chatShopper'){
                    PubSub.dispatch('message-chat', {message: payload?.data});
                    if(typeof window !== undefined && window.location.href.indexOf(payload?.data?.url) == -1) {
                        let action = (history) => {
                            if(history) history.push('/mis-compras/' + payload?.data?.url + '#chat');
                            else window.location.href = '/mis-compras/' + payload?.data?.url + '#chat';
                        }
    
                        PubSub.dispatch('open_tooltip', {action});
                        setTimeout(() => {
                            PubSub.dispatch('open_tooltip', false);
                        }, 5000);
                    }
                }
            });
        }
    },
    register: (newToken) => {
        const token = StorageService.getItem('notification');
        if(token !== newToken){
            StorageService.setItem('notification', newToken);
            StorageService.removeSecureItem('notification-register');
        }
        PushNotification.registerUser();
    },
    registerUser: () => {
        if(!(notificationsFlag && _messaging)) return false;

        const token = StorageService.getItem('notification');
        let deviceId = StorageService.getItem('deviceId');
        let oldEmail = StorageService.getSecureItem('notification-register');
        const userData = StorageService.getSecureItem('userData');
        const email = userData.email;
        let isRegistered = (oldEmail === email);

        if(isRegistered || !(email && token &&  window && window.navigator && window.navigator.userAgent)) return false;//validar

        const params = {
            "email": email,
            "deviceId": deviceId,
            "token": token,
            "isMobile": false,
            "device": window.navigator.userAgent
        };

        return fetch(`https://apijumboweb.smdigital.cl/notification/user`, {
            method: 'POST',
            headers: {
                'x-api-key': 'mlxRyMThFk3gMAydwL8QTa0GRbx4S9jy2grq6QD1',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        })
            .then(results => results.json())
            .then(() => {
                StorageService.setSecureItem('notification-register', email);
            });
    },

    removeToken: () => {
        const token = StorageService.getItem('notification');
        if(!token) return false;
        navigator.serviceWorker.getRegistrations().then((res) => {
            res.forEach(item => {
                if (item.scope.indexOf('firebase-cloud-messaging-push-scope') !== -1) {
                    item.unregister()
                    StorageService.removeItem('notification')
                    StorageService.setItem('notification-disable', true)
                    StorageService.removeSecureItem('notification-register')
                }
            })
        })
    }
}

const Analytics = {
    setUserId: (id) => {
        if(!(_analytics && _analytics.setUserId)) return false;

        _analytics.setUserId(id);
    }
}

PushNotification.initialize();

export default PushNotification;

export {
    Analytics
};
